
<div
  :class="[
    jel_getClassObject(content),
    getIsMenuGaucheOuvert ? 'menu-gauche-ouvert' : 'menu-gauche-ferme',
  ]"
>
  <div
    v-if="produit"
    :class="{
      'menu-droit-active': contentHeritageMenuDroit && $mq == 'xxl',
    }"
  >
    <b-container fluid class="bv-example-row">
      <b-row>
        <div
          class="p-0"
          :class="
            contentHeritageMenuDroit && !pleineLargeur && $mq == 'xxl' ? 'contenu-jeu' : 'col-12'
          "
        >
          <template v-if="idFamille">
            <b-row class="m-0 position-relative">
              <b-col class="col-12 col-xxl-8 p-0">
                <JeuCasinoJouer :produit="produit" :lienRetour="contentLien" />
              </b-col>
              <b-col
                class="col-12 col-xxl-4 d-flex justify-content-center flex-column px-0 pb-2 py-xxl-4 propriete-ced"
              >
                <JeuCasinoPropriete :produit="produit" />
                <JeuCasinoRegle :content="contentInfoRegle" />
              </b-col>
            </b-row>
            <b-row>
              <b-col class="col-12 p-0">
                <ListeHorizontale :content="contentListeHorizontaleApercu" />
              </b-col>
            </b-row>
          </template>
          <template v-else>
            <JeuCasinoJouer :produit="produit" :lienRetour="contentLien" />
            <div :class="{ 'd-flex': pleineLargeur }">
              <div :class="{ 'contenu-jeu d-float': pleineLargeur }">
                <JeuCasinoPropriete :produit="produit" />

                <ListeHorizontale
                  v-if="contentListeHorizontaleApercu"
                  :content="contentListeHorizontaleApercu"
                />
                <div
                  v-if="contentTxtLegalComplet"
                  class="txt-legal-defaut caption-4 order-md-3 col-12 col-md-8 pl-0 pl-sm-2 pr-xxl-7 mx-md-0 mb-3"
                >
                  <b-col v-html="jel_replaceTokens(contentTxtLegalComplet)" />
                </div>

                <JeuCasinoRegle :content="contentInfoRegle" />

                <ListeHorizontale
                  v-if="contentListeHorizontaleJeuxSimilaires"
                  :content="contentListeHorizontaleJeuxSimilaires"
                />
                <!-- TODO: contentListeHorizontaleEtiquette hors portée livraison 1 NAV001 -->
                <!-- <ListeHorizontale
                  v-if="contentListeHorizontaleEtiquette"
                  :content="contentListeHorizontaleEtiquette"
                /> -->
                <ListeHorizontale
                  v-if="contentListeHorizontaleCategorieTypeJeu"
                  class="mt-n1"
                  :content="contentListeHorizontaleCategorieTypeJeu"
                />
                <ListeHorizontale
                  v-if="contentListeHorizontaleFournisseur"
                  class="mt-n1"
                  :content="contentListeHorizontaleFournisseur"
                />

                <Heritage v-if="contentHeritageBas" :content="contentHeritageBas" />
              </div>
              <div
                v-if="contentHeritageMenuDroit && pleineLargeur"
                class="contenu-menu-droit d-none d-xxl-block bg-white border-left p-0"
              >
                <Heritage v-if="contentHeritageMenuDroit" :content="contentHeritageMenuDroit" />
              </div>
            </div>
          </template>
        </div>
        <div
          v-if="contentHeritageMenuDroit && !pleineLargeur"
          class="contenu-menu-droit d-none d-xxl-block bg-white border-left p-0"
        >
          <Heritage v-if="contentHeritageMenuDroit" :content="contentHeritageMenuDroit" />
        </div>
      </b-row>
    </b-container>
  </div>
  <div v-else>
    <div class="d-flex justify-content-center vh-100">
      <b-spinner
        variant="primary"
        class="align-self-center"
        type="grow"
        :label="$t('chargement')"
      />
    </div>
  </div>
</div>
